// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { LogLevel } from "@lib/logging/LogLevel";

/**
 * Provides an API for logging messages.
 */
export interface ILogger
{
  enabled: boolean;
  logLevel: LogLevel;
  log(logLevel: LogLevel, format: string, args: any[]): void;
}